<div class="ama-logo-text" (click)="onLogoClicked()">
  annuaire des <span class="ama-logo-text-highlighted">magistrats</span>
</div>
